var _rect, _rect2, _line, _line2, _line3, _line4, _line5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 58,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 57,
    stroke: "black",
    strokeOpacity: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 15.5,
    x2: 83,
    y2: 15.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 28.5,
    x2: 84,
    y2: 28.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 43.5,
    x2: 84,
    y2: 43.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 2.22386e-8,
    x2: 15.5,
    y2: 58,
    stroke: "black",
    strokeOpacity: 0.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 53.5,
    y1: 2.22386e-8,
    x2: 53.5,
    y2: 58,
    stroke: "black",
    strokeOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 33,
    height: 5,
    fill: "#B3C2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 20,
    width: 25,
    height: 5,
    fill: "#ACCDFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    width: 33,
    height: 5,
    fill: "#B3C2FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 34,
    width: 25,
    height: 5,
    fill: "#ACCDFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 48,
    width: 33,
    height: 5,
    fill: "#B3C2FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 25,
    height: 5,
    fill: "#ACCDFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.ace68581d6dc47904076c5f503f3ef1b.svg";
export { ForwardRef as ReactComponent };